<script>
    import BrandImage from "@xd/components/BrandImage";
    import BrandLink from "@xd/components/BrandLink";

    export default {
        name: "BrandProductXL",
        components: { BrandLink, BrandImage },
        props: {
            product: Object,
            visibleElements: Array,
        },
        methods: {
            checkElement(index) {
                return !this.visibleElements.includes(index.toString());
            },
        },
    };
</script>

<template>
    <div class="brand-product" :id="product.slug">
        <div class="l-container">
            <div
                class="brand-product__blur"
                :class="{ 'is-animated': checkElement('blur') }"
                data-name="blur"
            >
                <img src="/static/xd-design/brand-history/blur.svg" alt="" />
            </div>

            <svg
                class="brand-product__line is-mobile"
                :class="{ 'is-animated': checkElement('line-mobile') }"
                data-name="line-mobile"
                width="469"
                height="587"
                viewBox="0 0 469 587"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="m19.893 1 448.538 45.472-40.656 539.216L.637 301.513 19.893 1Z"
                    stroke="#182028"
                    stroke-width=".5"
                />
            </svg>

            <svg
                class="brand-product__line is-desktop"
                :class="{ 'is-animated': checkElement('line-desktop') }"
                data-name="line-desktop"
                width="804"
                height="1004"
                viewBox="0 0 804 1004"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M34.507 1 803.18 78.927 733.507 1003l-732-487.001L34.507 1Z"
                    stroke="#000"
                />
            </svg>

            <div class="brand-product__body">
                <div class="brand-product__col">
                    <header class="brand-product__header">
                        <div
                            class="brand-product__title"
                            :class="{ 'is-animated': checkElement('title') }"
                            data-name="title"
                        >
                            {{ product.title }}
                        </div>
                        <div
                            class="brand-product__date"
                            :class="{ 'is-animated': checkElement('date') }"
                            data-name="date"
                        >
                            {{ product.date }}
                        </div>
                    </header>

                    <div class="brand-product__image image-1">
                        <brand-image
                            :image="product.image"
                            index="1"
                            :is-animated="checkElement('image-1')"
                            data-name="image-1"
                        ></brand-image>
                    </div>
                </div>

                <div class="brand-product__col">
                    <div
                        class="brand-product__text text-1"
                        :class="{ 'is-animated': checkElement('text-1') }"
                        data-name="text-1"
                        v-html="product.text[0]"
                    ></div>
                    <div
                        class="brand-product__text text-2"
                        :class="{ 'is-animated': checkElement('text-2') }"
                        data-name="text-2"
                        v-html="product.text[1]"
                    ></div>
                    <div
                        class="brand-product__text text-3"
                        :class="{ 'is-animated': checkElement('text-3') }"
                        data-name="text-3"
                        v-html="product.text[2]"
                    ></div>

                    <div class="brand-product__image image-2">
                        <brand-image
                            :image="product.image"
                            index="2"
                            :is-animated="checkElement('image-1')"
                            data-name="image-1"
                        ></brand-image>
                    </div>

                    <brand-link
                        class="brand-product__link"
                        :slug="product.slug"
                        :is-animated="checkElement('link')"
                        data-name="link"
                    ></brand-link>
                </div>
            </div>
        </div>

        <div
            class="brand-product__year"
            :class="{ 'is-animated': checkElement('year') }"
            data-name="year"
        >
            <img src="/static/xd-design/brand-history/years/2018.svg" alt="" />
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .brand-product {
        padding: 100px 16px 60px;
        @include bp($bp-desktop-sm) {
            padding: 100px 0 390px;
        }
    }

    .brand-product__header {
        margin-bottom: 40px;
        @include bp($bp-desktop-lg) {
            margin-bottom: 80px;
        }
    }

    .brand-product__body {
        @include bp($bp-desktop-lg) {
            display: flex;
            margin: 0 -90px;
        }
    }

    .brand-product__col {
        @include bp($bp-desktop-lg) {
            flex-grow: 1;
            margin: 0 90px;
            &:first-child {
                flex-basis: 604px;
                max-width: 604px;
            }
            &:last-child {
                display: flex;
                flex-direction: column;
            }
        }
    }

    .brand-product__image {
        &.image-1 {
            margin-bottom: 40px;
            &::before {
                padding-bottom: 144%;
            }
            @include bp($bp-desktop-lg) {
                max-width: 604px;
                margin-bottom: 0;
            }
        }

        &.image-2 {
            width: calc(100% + 32px);
            margin-right: -32px;
            margin-bottom: 40px;
            &::before {
                padding-bottom: 62.8%;
            }
            @include bp($bp-desktop-lg) {
                order: -1;
                max-width: none;
                width: 565px;
                margin-right: -90px;
                margin-bottom: 55px;
            }
        }
    }

    .brand-product__text {
        @include bp($bp-desktop-lg) {
            max-width: 476px;
        }
        &.text-1 {
            margin-bottom: 16px;
            @include bp($bp-desktop-lg) {
                margin-bottom: 24px;
            }
        }

        &.text-2 {
            margin-bottom: 16px;
            @include bp($bp-desktop-lg) {
                margin-bottom: 24px;
            }
        }

        &.text-3 {
            margin-bottom: 40px;
        }
    }

    .brand-product__link {
        @include bp($bp-desktop-lg) {
            margin-top: auto;
        }
    }

    .brand-product__year {
        left: -490px;
        bottom: 5px;
        width: 810px;
        &.is-animated {
            transform: translateX(-15%);
        }
        @include bp($bp-desktop-lg) {
            left: -145px;
            bottom: 130px;
            width: 1490px;
            &.is-animated {
                transform: translateX(-20%);
            }
        }
    }

    .brand-product__line {
        top: -100px;
        right: -2px;
        stroke-dashoffset: 0;
        stroke-dasharray: 1806;
        transition: all 3s ease-in;
        animation-duration: 4.7s;
        animation-delay: 3.2s;
        &.is-animated {
            stroke-dashoffset: 1806;
        }
        @include bp($bp-desktop-lg) {
            top: -80px;
            left: -140px;
            right: auto;
            stroke-dasharray: 3095;
            &.is-animated {
                stroke-dashoffset: 3095;
            }
        }
    }

    .brand-product__blur {
        left: 40px;
        bottom: -170px;
        @include box(201px);
        @include bp($bp-desktop-lg) {
            display: none;
        }
    }
</style>
